module.exports = __webpack_public_path__ + "static/img/logo.fb2ee2c8.svg";